/* eslint-disable import/no-anonymous-default-export */
import GlobalConsts from '../../Utils/Constants/GlobalConsts';
import AuthConstants from './AuthConsts'

const initialState = {
    data: '',
    message: '',
    status: false,
    token: '',
    isAuthenticated: false,
    theme: localStorage.theme || GlobalConsts.LIGHT,
    currentRoute: window.location.pathname || '/home',
    reset: false,
    signedUp: false,
    exceeded: false,
    user: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case AuthConstants.CHANGE_THEME: {
            return {
                ...state,
                theme: action.payload.theme,
            };
        }
        case AuthConstants.LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.data.token,
                user: action.payload.data.user,
            };
        }
        case AuthConstants.CHECK_LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.data.user,
            };
        }
        case AuthConstants.LOGOUT: {
            return {
                ...state,
                isAuthenticated: false,
            };
        }
        case AuthConstants.RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                reset: true,
            };
        }
        case AuthConstants.SIGN_UP_SUCCESS: {
            return {
                ...state,
                signedUp: true,
            };
        }
        case AuthConstants.SIGN_UP_DISABLE: {
            return {
                ...state,
                signedUp: false,
            };
        }
        case AuthConstants.REDIRECT_SCREEN: {
            return {
                ...state,
                currentRoute: action.payload.currentRoute || window.location.pathname
            };
        }
        case AuthConstants.USER_EXCEEDED: {
            return {
                ...state,
                exceeded: true,
            };
        }
        case AuthConstants.CLEAR_USER_EXCEEDED: {
            console.log('CLEAR_USER_EXCEEDED');
            return {
                ...state,
                exceeded: false,
            };
        }
        default:
            return state
    }
}